import { Flex } from 'antd';
import { TabItem, TabItemContent, TabItemTitle } from './style';
import { RightOutlined } from '@ant-design/icons';
import { useTheme } from 'styled-components';

const ToBeReviewItem = ({
  name,
  description,
  onClick,
}: {
  name?: string;
  description?: string;
  onClick?: () => void;
}) => {
  const theme = useTheme();
  return (
    <TabItem onClick={onClick}>
      <Flex vertical gap={2}>
        <TabItemTitle>{name || '-'}</TabItemTitle>
        <TabItemContent>{description || '-'}</TabItemContent>
      </Flex>
      <RightOutlined style={{ color: theme.antd.colorTextDisabled }} />
    </TabItem>
  );
};

export default ToBeReviewItem;
